import React, { useEffect, useState } from 'react';
import * as storage from './storage';
import { withRouter } from '@/_helper/withRouter';
import { Navigate, useNavigate } from 'react-router';
import axios from 'axios';
import publicPages from '@/_data/publicPages';
import { setupCookie, getCookie, listenCookieChange } from './mapper';
import { buildPostRequest } from './apiHelper';

let params = {
    allowRequestCall: true,
    cancelVacancy: null,
    refreshTime: 20,
    loops: 0,
    maxLoopsBeforeCanceling: 5,
};

function UpdateBookingData() {
    if (window.location.hash === '#/uebersicht') {
        return false;
    }

    if (!params.allowRequestCall) {
        return false;
    }

    params.allowRequestCall = false;

    let newHash = null,
        CancelToken = axios.CancelToken;

    let loginData = {
        action: 'login',
        bookingId: storage.get('bookingNumber'),
        firstPaxName: storage.get('firstPaxName'),
        travelStart: storage.get('travelStart'),
        clientId: 'customerarea',
        requestSource: 'AurumTours-Customerarea',
        requestType: 'bookingData',
    };

    async function call() {
        let newBookingData = null;
        if (storage.get('refreshData') === null) {
            clearInterval(interval);
            return false;
        }

        await axios({
            ...buildPostRequest(window.$serviceUrl, '/bookingData', loginData),
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                params.cancelVacancy = c;
            }),
        })
            .then((response) => response)
            .then(function (response) {
                params.allowRequestCall = true;

                if (response.data.data.hash !== null) {
                    newBookingData = response.data.data;
                    newHash = response.data.data.hash;
                } else {
                    throw new Error(response.data.data.errorMessage);
                }
            })
            .catch(function (thrown) {
                if (axios.isCancel(thrown)) {
                    params.loops++;
                }
            });
        return newBookingData;
    }

    let interval = setInterval(async function () {
        let bookingData = storage.get('bookingData');
        let newBookingData = await call();

        if (newBookingData && JSON.stringify(bookingData.data) !== JSON.stringify(newBookingData.data)) {
            clearInterval(interval);

            storage.remove('refreshData');

            storage.set('bookingData', newBookingData, true);
            storage.set('access_token', newHash);
            storage.set('newData', true);

            setTimeout(function () {
                storage.remove('newData');
                window.location.reload();
            }, 100);
        }

        // fallback : max loops -> hard canceling
        if (params.loops > params.maxLoopsBeforeCanceling) {
            clearInterval(interval);

            storage.remove('refreshData');
            storage.set('newData', true);
            setTimeout(function () {
                storage.remove('newData');
                window.location.reload();
            }, 100);
        }

        params.loops++;
    }, params.refreshTime * 1000);
}

function initBlockLayer(block) {
    if (!block) {
        return false;
    }
    return <Navigate to="revalidierung" replace={false} />;
}

export const getBookingData = (accessToken) => {
    if (accessToken === undefined) {
        return false;
    }

    let bookingData = storage.get('bookingData');

    let d = bookingData.travelStart?.split('.');
    let travelStart = d[0] + '.' + d[1] + '.' + d[2];

    if (bookingData.bookingId && bookingData.firstPaxName && travelStart) {
        const loginData = {
            requestType: 'bookingData',
            action: 'login',
            bookingId: bookingData.bookingId.toString(),
            firstPaxName: bookingData.firstPaxName,
            travelStart: travelStart,
            clientId: 'customerarea',
            requestSource: 'AurumTours-Customerarea',
        };

        return axios(buildPostRequest(window.$serviceUrl, '/bookingData', loginData))
            .then((response) => response)
            .then((response) => {
                let bookingData = response.data.data;
                if (bookingData !== undefined && bookingData.errorMessage === null) {
                    storage.set('bookingData', bookingData);
                    return Promise.resolve();
                } else {
                    return Promise.reject();
                }
            })
            .catch(() => {
                return Promise.reject();
            });
    }
};

function setAutoLogoutInsteadOfRefreshLogin() {
    // set atomatic logout
    const min = 120;
    const login_timestamp = storage.get('login_timestamp');

    if (null === login_timestamp || login_timestamp + min * 60000 >= new Date().getTime()) {
        return null;
    }

    storage.set('autoLogoutInsteadOfRefreshLogin', true);
}

const FetchNewData = ({ location }) => {
    const navigate = useNavigate();
    const [block, setBlock] = useState(false);

    useEffect(() => {
        if (window.$revalidateEnabled && storage.get('refreshData') !== null && location?.pathname !== '/uebersicht') {
            setBlock(true);
        }
    }, [location]);

    if (storage.get('access_token') === null) {
        return false;
    }

    // rebookConnectionSync
    function rebookConnectionSync() {
        const reBookSuccess = () => {
            if (getCookie('_rebook-success') === 'true' && location?.pathname !== '/revalidierung') {
                storage.set('refreshData', new Date().getTime());
                setupCookie('_rebook-success', 'false');
                initBlockLayer(true);
                navigate('/revalidierung');
            }
        };
        reBookSuccess();

        let bookingData = storage.get('bookingData');
        if (bookingData?.data.allowHotelRebooking || bookingData?.data.allowFTCRebooking) {
            listenCookieChange(() => {
                reBookSuccess();
            }, 1000);
        }
    }

    if (window.$revalidateEnabled) {
        rebookConnectionSync();
    }

    setAutoLogoutInsteadOfRefreshLogin();

    // ***** set localstorage *****
    //  new access token && set refreshData : true
    // **** ***** ***** ***** *****
    // localStorage.access_token = "eb69334e9bd66a44ca3c097cf8b7fd8fe48f0364"
    // localStorage.refreshData = true
    if (window.$revalidateEnabled && storage.get('refreshData') !== null) {
        UpdateBookingData();
    }

    window.addEventListener('storage', (event) => {
        if (event.key === null) {
            return false;
        }

        let noRedirect = false;
        publicPages.forEach((page) => {
            if (window.location.href.includes(page)) {
                noRedirect = true;
            }
        });

        switch (true) {
            // auto login : tabs open
            case event?.key.includes('login'):
                if (noRedirect) {
                    window.location.reload();
                } else {
                    navigate('/');
                }
                break;
            // auto logout : tabs open
            case event?.key.includes('logout'):
                if (noRedirect) {
                    window.location.reload();
                } else {
                    navigate('/login');
                }
                break;
            case event?.key.includes('excursionOffers'):
                if (event.newValue === null && window.location.toString().includes('ausfluege')) {
                    window.location.reload();
                }
                break;
            case event?.key.includes('refreshData'):
                if (window.$revalidateEnabled) {
                    UpdateBookingData(storage.get('access_token'));
                    if (location?.pathname !== '/uebersicht') {
                        setBlock(event?.newValue !== null);
                    }
                }
                break;
            case event?.key.includes('newData'):
                setBlock(false);
                navigate('/');
                break;
            default:
        }
    });

    return <>{location?.pathname !== '/uebersicht' && initBlockLayer(block)}</>;
};

export default withRouter(FetchNewData);
